import { useMemo } from 'react';
import { isRequired } from '@utils/yup';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useIsRequired = <T extends object,>(...args: Parameters<typeof isRequired<T>>) => {
  return useMemo(() => isRequired(...args), [args]);
};
